var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"books_skleton"},_vm._l((_vm.number),function(book,index){return _c('BookSkeleton',{key:index})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }